import { useState } from 'react';
import {
  faChevronDown,
  faChevronUp,
  faThumbtack,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@design-system/components/typography/typography';
import { useCommunityPinnedPosts } from '../api/useCommunityPinnedPosts';
import { useToggleReaction } from '../api/useToggleReaction';
import { useCommunityContext } from '../lib/communityContext';
import { ReactionParent } from '../model/post.types';
import { PostCard } from './PostCard';

export const PinnedPostsSection = () => {
  const { communityId, canModerate } = useCommunityContext();
  const pinned = useCommunityPinnedPosts(communityId, canModerate);
  const toggleReaction = useToggleReaction(communityId);
  const [isCollapsed, setIsCollapsed] = useState(true);

  if (pinned.type !== 'fetched' || pinned.value.length === 0) return null;

  const posts = pinned.value;

  return (
    <section className="flex w-full flex-col rounded-[10px] bg-[#EDE5FC] p-2">
      <button
        type="button"
        onClick={() => setIsCollapsed((collapsed) => !collapsed)}
        className="flex items-center justify-between px-2 py-1"
      >
        <span className="flex items-center gap-3">
          <FontAwesomeIcon
            icon={faThumbtack}
            className="text-[12px] text-black"
          />
          <Typography
            as="span"
            variant="body"
            size="small"
            fontWeight="medium"
            className="uppercase tracking-[1px] text-black"
          >
            Pinned Posts ({posts.length})
          </Typography>
        </span>
        <span className="flex items-center gap-2">
          <Typography
            as="span"
            variant="body"
            size="small"
            fontWeight="medium"
            className="text-[#131313]"
          >
            {isCollapsed ? 'Show' : 'Hide'}
          </Typography>
          <FontAwesomeIcon
            icon={isCollapsed ? faChevronDown : faChevronUp}
            className="text-[12px] text-black"
          />
        </span>
      </button>
      {!isCollapsed && (
        <div className="flex flex-col divide-y divide-white">
          {posts.map((post) => (
            <PostCard
              key={post.id}
              post={post}
              pinnedCount={posts.length}
              showPinnedStyle={false}
              onToggleReaction={(type) =>
                toggleReaction({
                  parent: ReactionParent.Post,
                  entityId: post.id,
                  type,
                })
              }
            />
          ))}
        </div>
      )}
    </section>
  );
};
